import { createLoading } from "../../../../utils/loading";
import store from "../../../../store";
import { reactive, toRaw } from "vue";
import lodash from "lodash";
import { initUseForm, onClickEdit, onClickView } from "../../../../utils/form";
import { validateError } from "../../../../utils/validate";

import { flatWhereGroup } from "../../../../utils/search";
import i18n from "../../../../i18n";
import { notification } from "ant-design-vue";

import { createManageExportCsv, createManageSelect, createPage, createRowActionEdit, createRowActionView } from "../../../../utils/page";
import { createConditionAction } from "./my-job.condition";
import { createColumns } from "./MyJob.section";

export const { isLoading, setIsLoading } = createLoading();
export const actionPrefix = "resource/v1/transaction/licenseRequest";

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callCancelBookLicense = ({ licenseRequestIds }) => store.dispatch(`resource/v1/transaction/bookLicenseRequest/cancelAssignTo`, { licenseRequestIds, config: { params: { isHardDelete: true } } });

export const onSearch = ({ props, page, state }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);

    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...customWhere, ...createWhereFor({ props })], sort } })
        .then((page) => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: ["**"],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [],
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [],
        };
    }
};

export const createWhereFor = () => {
    // const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    const where = { name: "bookLicenseRequests.refBookedBy.id", type: "UUID", operator: "=", value: userInfo.id };
    whereGroup.push(where);
    return [{ name: "isTemp", type: "Boolean", operator: "=", value: true }, ...flatWhereGroup({ where: whereGroup, logic: "OR" })];
};

export const createForm = () => {
    return {};
};

export const createRules = () => {
    return {};
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    return modelRef.id ? `${modelRef.name} (${modelRef.refStatus?.value})` : i18n.global.t("button.create");
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then((page) => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = () => {
    const promises = [];
    return Promise.all(promises);
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    // todo: จองงานแล้วงานไม่หายไปจากหน้างานทั้งหมด + จองซ้ำได้
    state.manages = [
        createManageSelect({ menuContext }),
        {
            icon: () => <CIcon file="book.svg"></CIcon>,
            text: () => i18n.global.t("button.cancelBookingRequest"),
            force: false,
            visible: () => true,
            rowSelection: true,
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map((d) => d.name).join(", ") }),
            buttonProp: { class: "btn-primary" },
            onClick: ({ rowSelection }) => {
                setIsLoading(true);
                return callCancelBookLicense({ licenseRequestIds: rowSelection?.selectedRowKeys })
                    .then(() => notification["success"]({ message: i18n.global.t(`views.request.licenseRequest.cancelBookingRequestSuccess`) }))
                    .then(() => onSearch({ props, page: state.page, state }))
                    .finally(() => setIsLoading(false));
            },
        },
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [];
    state.rowActions = [
        createRowActionView({
            menuContext,
            onClick: ({ record }) => {
                let routerPrefixform = routerPrefix;
                if ("changeLicense".includes(record.refRequestType?.key)) {
                    routerPrefixform = `change-${routerPrefix}`;
                } else if ("requestReplacement".includes(record.refRequestType.key)) {
                    routerPrefixform = `replacement-${routerPrefix}`;
                } else if ("cancelLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `cancel-${routerPrefix}`;
                } else if ("renewLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `renew-${routerPrefix}`;
                } else if ("transferLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `transfer-${routerPrefix}`;
                }
                onClickView({ record, routerPrefix: routerPrefixform, props: { isRouteFromMyJob: true }  });
            },
        }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => {
                let routerPrefixform = routerPrefix;
                if ("changeLicense".includes(record.refRequestType?.key)) {
                    routerPrefixform = `change-${routerPrefix}`;
                } else if ("requestReplacement".includes(record.refRequestType.key)) {
                    routerPrefixform = `replacement-${routerPrefix}`;
                } else if ("cancelLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `cancel-${routerPrefix}`;
                } else if ("renewLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `renew-${routerPrefix}`;
                } else if ("transferLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `transfer-${routerPrefix}`;
                }
                onClickEdit({ record, routerPrefix: routerPrefixform, props: { isRouteFromMyJob: true }  });
            },
            visible: ({ record }) => state.conditionAction.canEdit({ props, record }),
        }),
    ];
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: ["**"],
            sort: [{ name: "updateDate", type: "DESC" }],
        },
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction(),
});
